var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineLocationSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.04 13.65a3.875 3.875 0 0 1-1.91-3.33 3.867 3.867 0 0 1 7.21-1.95.752.752 0 1 1-1.3.76c-.42-.74-1.2-1.19-2.04-1.19-1.3 0-2.37 1.06-2.37 2.37 0 .84.45 1.62 1.17 2.04.36.21.48.67.27 1.03-.14.23-.39.37-.65.37-.13 0-.26-.03-.38-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38 18.25c-2.4-3.29-3.24-6.63-2.49-9.93.78-3.43 3.3-5.97 6.74-6.8 3.6-.87 7.38.3 9.61 2.97.27.32.22.79-.09 1.06a.75.75 0 0 1-1.06-.1c-1.87-2.24-5.05-3.21-8.11-2.48-2.92.7-4.97 2.77-5.63 5.67-.65 2.86.1 5.79 2.24 8.71.24.33.17.8-.16 1.05-.13.11-.29.16-.44.16-.23 0-.46-.11-.61-.31zM7.87 21.09a.746.746 0 0 1-.02-1.06c.29-.3.76-.31 1.06-.02a4.426 4.426 0 0 0 6.17 0c2.67-2.57 5.63-6.63 4.57-11.34a.753.753 0 0 1 1.47-.33c1.22 5.39-2.04 9.91-4.99 12.75A5.97 5.97 0 0 1 12 22.76a5.97 5.97 0 0 1-4.13-1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47 22.53a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineLocationSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-location-slash.d3dcaaec3ce56221d667241d2cf2e1a4.svg";
export { ForwardRef as ReactComponent };